import { useRouteQuery } from "@vueuse/router";

export const useRouteGenerator = () =>
  useRouteQuery<string, number>("generator_id", "", {
    mode: "push",
    transform: {
      // TODO: This results in a NaN if the value is not a number
      // Is that expected behavior?
      get: (value) => Number.parseInt(value),
      set: (value) => (value ? String(value) : ""),
    },
  });
